export const typeOfHeatmapCellDetailsDialog = 'typeOfHeatmapCellDetailsDialog';
export const HEATMAP_CELL_DETAILS_DIALOG_CONTENT_CLASS_NAME = 'heatmap-cell-details-dialog__content';
